import React, { useState } from "react";
import { Link } from "gatsby-plugin-react-i18next";
import { useTranslation } from "react-i18next";
import { Box, Menu, MenuItem, Stack, Typography } from "@mui/material";
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';

const paperProps = {
  elevation: 0,
  sx: {
    minWidth: 155,
    overflow: "visible",
    filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
    mt: 1.5,
    "& .MuiAvatar-root": {
      width: 32,
      height: 32,
      ml: -0.5,
      mr: 1,
    },
    "&::before": {
      content: '""',
      display: "block",
      position: "absolute",
      top: 0,
      right: 14,
      width: 10,
      height: 10,
      bgcolor: "background.paper",
      transform: "translateY(-50%) rotate(45deg)",
      zIndex: 0,
    },
  },
};

export default function ServicesMenu({ label, to }) {
  const { t } = useTranslation();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    event.preventDefault();
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <Box sx={{ display: "flex", alignItems: "center", textAlign: "center" }}>
        <Link onClick={handleClick} to={to} style={{ textDecoration: "none" }}>
          <Stack flexDirection="row" gap={0.5}>
            <Typography
              sx={{
                cursor: "pointer",
                transition: "color 0.3s ease",
                "&:hover": {
                  textDecoration: "underline",
                  color: "primary.light",
                },
              }}
              color="secondary"
              variant="body1"
            >
              {label}
            </Typography>

            {open ? <ArrowDropUpIcon sx={{ color: 'primary.light' }} /> : <ArrowDropDownIcon sx={{ color: 'primary.light' }} />}
          </Stack>
        </Link>
      </Box>
      <Menu
        id="services-menu"
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        anchorEl={anchorEl}
        slotProps={{ paper: paperProps }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
      >
        <MenuItem component={Link} to="/tickets">{t("footer.tickets")}</MenuItem>
        <MenuItem component={Link} to="/parking">{t("footer.parking")}</MenuItem>
        <MenuItem component={Link} to="/cbx-shuttle">{t("footer.shuttle")}</MenuItem>
        <MenuItem component={Link} to="/unaccompanied-teen">{t("footer.unaccompanied")}</MenuItem>
        <MenuItem component={Link} to="/assisted-pass">{t("footer.assisted")}</MenuItem>
        <MenuItem component={Link} to="/services">{t("footer.services")}</MenuItem>
        <MenuItem component={Link} to="/additional-services">{t("footer.external_services")}</MenuItem>
      </Menu>
    </>
  );
}
